import { apiAxios } from '@/api/axios';
import type { UserDisplay } from '@/api/types/UserDisplay';

// Users-display service — wraps `GET /api/users-display`. Returns EVERY KC
// user (regardless of role membership or enabled state) projected to a narrow
// `{sub, displayName, state}` shape; used by `usersSlice` to populate the
// generic sub→displayName resolver cache on app boot. Companion to
// `dispatchersService`; together they back the chained `selectAssignedUserName`
// selector that fixes the partial-resolution bug from [[dispatcher-display-name]].

export const getUsersDisplay = async (): Promise<UserDisplay[]> => {
  const response = await apiAxios.get<UserDisplay[]>('/api/users-display');
  return response.data;
};
